<template>
  <div v-if="hasWebkassaRight" class="mb-3">
    <b-button class="btn-collapse"
              v-spaceduck-collapse="`collapse-webkassa`">
      Webkassa
    </b-button>
    <spaceduck-collapse id="collapse-webkassa"
                        @show="initialLoad">
      <div class="pt-4">
        <div class="alert alert-info" v-if="!ppoData.error">{{ $t('data_is_valid') }}</div>
        <div class="alert alert-danger" v-if="ppoData.error">{{ $t('data_is_invalid') }}</div>
        <InputGroup v-model="webkassa.webkassa_email"
                    class="mb-3"
                    :label="$t('email')"/>
        <InputGroup v-model="webkassa.webkassa_password"
                    class="mb-3"
                    :label="$t('password')"/>
        <SelectGroup :label="$t('cashdesk')"
                     class="mb-3"
                     v-if="cashdesks.length"
                     :options="cashdesks"
                     variant="white"
                     title="UniqueNumber"
                     valuekey="UniqueNumber"
                     :showlabel="true"
                     :null-option="false"
                     v-model="webkassa.webkassa_kassa"/>
        <InputGroup v-model="webkassa.webkassa_service"
                    v-if="cashdesks.length"
                    class="mb-3"
                    :label="$t('name_of_service_in_cheque')"/>
        <ServiceMultiSelect :label="$t('pay_methods_cash')"
                            :dblclick="false"
                            model="pay_method"
                            title="translatedTitle"
                            class="mb-3"
                            :dbsearch="false"
                            :prepopulatedOptions="pay_methods"
                            v-model="webkassa.webkassa_cashmethods"/>
        <InputGroup v-model="webkassa.webkassa_vat"
                    class="mb-3"
                    type="number"
                    :label="$t('vat_rate')+ ' (%)'"/>
        <div class="mt-4">
          <button class="btn btn-themed btn-themed-squared"
                  :disabled="loading"
                  @click="saveWebkassa">
            {{ $t('save') }}
          </button>
        </div>
      </div>
    </spaceduck-collapse>
  </div>
</template>

<script>
import { ClinicService } from "@/services/api/clinic.api.service"
import { CashdeskService } from "@/services/api/cashdesk.api.service"
import {mapGetters, mapState} from "vuex"
import InputGroup from "@/components/form/InputGroup.vue"
import SelectGroup from "@/components/form/SelectGroup"
import ServiceMultiSelect from "@/components/form/ServiceMultiSelect.vue"
import SpaceduckCollapse from "@/components/parts/general/SpaceduckCollapse.vue"

export default {
  name: "WebkassaIntegration",
  emits: ['update'],
  components: {
    SpaceduckCollapse,
    ServiceMultiSelect,
    InputGroup,
    SelectGroup
  },
  computed: {
    ...mapState({
      clinic: state   => state.auth.clinic,
      superadmin: state => state.auth.superadmin,
      rights: state => state.auth.rights,
      loading: state => state.dom.loading,
      ppoData: state => state.ppo.ppoData,
      pay_methods: state => state.auth.pay_methods,
      branch: state => state.auth.branch
    }),
    ...mapGetters([
      'dynamicConfigValue'
    ]),
    hasWebkassaRight() {
      return this.rights.includes('webkassa')
    }
  },
  data() {
    return {
      webkassa: {
        webkassa_email: '',
        webkassa_password: '',
        webkassa_kassa: '',
        webkassa_service: '',
        webkassa_cashmethods: '',
        webkassa_vat: '',
      },
      cashdesks: []
    }
  },
  methods: {
    async saveWebkassa() {
      await ClinicService.saveDynamicConfigs([
        {
          id: 'webkassa_email',
          value: this.webkassa.webkassa_email,
          subgroup: 'webkassa',
          branchId: this.branch
        },
        {
          id: 'webkassa_password',
          value: this.webkassa.webkassa_password,
          subgroup: 'webkassa',
          branchId: this.branch
        },
        {
          id: 'webkassa_kassa',
          value: this.webkassa.webkassa_kassa,
          subgroup: 'webkassa',
          branchId: this.branch
        },
        {
          id: 'webkassa_service',
          value: this.webkassa.webkassa_service,
          subgroup: 'webkassa',
          branchId: this.branch
        },
        {
          id: 'webkassa_cashmethods',
          value: this.webkassa.webkassa_cashmethods.map(x => x.id),
          subgroup: 'webkassa',
          branchId: this.branch
        },
        {
          id: 'webkassa_vat',
          value: this.webkassa.webkassa_vat,
          subgroup: 'webkassa',
          branchId: this.branch
        },
      ], this.superadmin, this.clinic.id)
      this.$noty.info(this.$t('success_message'))
      await this.getCashdesks()
      this.$emit('update')
    },
    async getCashdesks() {
      const res = await CashdeskService.webkassaData('cashdesks')
      this.cashdesks = res.data
    },
    async initialLoad() {
      await this.getCashdesks()
      this.webkassa.webkassa_email = this.dynamicConfigValue('webkassa_email', this.branch)
      this.webkassa.webkassa_password = this.dynamicConfigValue('webkassa_password', this.branch)
      this.webkassa.webkassa_kassa = this.dynamicConfigValue('webkassa_kassa', this.branch)
      this.webkassa.webkassa_service = this.dynamicConfigValue('webkassa_service', this.branch)
      this.webkassa.webkassa_vat = this.dynamicConfigValue('webkassa_vat', this.branch)
      this.webkassa.webkassa_cashmethods = []
      let cashMethods = this.dynamicConfigValue('webkassa_cashmethods', this.branch)
      if(cashMethods) this.webkassa.webkassa_cashmethods = this.pay_methods.filter(p => cashMethods.includes(p.id))
    },
  },
}
</script>
